import React, { useCallback, useMemo } from 'react'
import block from 'bem-cn'

import { LocaleProfileKeysType, LocaleProfileType } from 'shared/locale/en-US'
import { DocumentTypes } from 'shared/models/Profile'

import { IDocumentItem } from '../Documents/Document.utils'

import './ChooseDocument.scss'

interface IChooseDocument {
  changeDocumentType: (system: DocumentTypes | '') => void
  documentList: IDocumentItem[]
  locale: LocaleProfileType
}

const b = block('choose-document')

const ChooseDocument: React.FC<IChooseDocument> = ({ changeDocumentType, documentList, locale }) => {
  const onChangeDocumentType = useCallback(
    (value: DocumentTypes | '') => {
      changeDocumentType(value)
    },
    [changeDocumentType],
  )

  const allMethods = useMemo(
    () =>
      documentList.map(document => (
        <div
          key={document.name}
          className={b('method')}
          onClick={() => onChangeDocumentType(document.value as DocumentTypes)}>
          <span className={b('icon-wrapper')}>
            <document.icon className={b('document-icon')} />
          </span>
          <span className={b('text')}>{locale[document.name as LocaleProfileKeysType]}</span>
        </div>
      )),
    [documentList, onChangeDocumentType, locale],
  )

  return (
    <div className={b()}>
      <div className={b('all-methods')}>{allMethods}</div>
    </div>
  )
}

export default ChooseDocument
